<script>
  import RichText from "$lib/components/RichText.svelte";
  import Heading from "$lib/components/Heading.svelte";
  import ImageComponent from "$lib/contentTypes/ImageComponent.svelte";
  import PageBody from "$lib/components/Page/PageBody.svelte";
  import Eyebrow from "$lib/components/Eyebrow.svelte";

  export let page;
  let eyebrow = {
    link: page.fields.eyebrowLink?.fields.url,
    content: page.fields.eyebrowLink?.fields.text
  };
</script>

<!-- profile -->
<div class="w-full lg:max-w-screen-lg md:pr-175 lg:px-0 m-auto">
  {#if eyebrow.content}
    <Eyebrow class="lg:pt-48 pt-24 m-auto" {...eyebrow} />
  {/if}

  <div class="flex flex-col md:flex-row">
    <!-- photo -->
    {#if page.fields.imageComponent}
      <ImageComponent
        containerClass="flex-shrink-0 self-center md:self-start px-54 lg:pl-70 pt-48 lg:pt-94 lg:pr-0 md:left-[-15%] lg:left-0 relative"
        elementClass="w-252 lg:w-575 aspect-square m-auto object-cover rounded-full md:clip-left lg:clip-none"
        data={page.fields.imageComponent}
        displayCaption={false}
        resizeParams={{ fit: "scale" }}
        containerized={true}
        sm={"252px"}
        lg={"575px"}
        responsive
      />
    {/if}

    <!-- details -->
    <div class="grow w-full flex flex-col px-24 py-48 lg:p-72 gap-y-16 lg:gap-y-24">
      <Heading class="heading-2 !text-size-24 lg:!text-size-56" text={page.fields.name} />

      {#if page.fields.role || page.fields.location}
        <div class="pt-8 lg:pt-24 flex flex-col gap-y-24 lg:text-size-20">
          {#if page.fields.role}
            <h2 class="sr-only">Role</h2>
            <p>{page.fields.role}</p>
          {/if}

          {#if page.fields.location}
            <h2 class="sr-only">Location</h2>
            <p>{page.fields.location}</p>
          {/if}
        </div>
      {/if}

      <div class="pt-32 lg:pt-24 flex flex-col gap-24">
        <!-- bio -->
        {#if page.fields.fullBio != null}
          <h2 class="sr-only">Biography</h2>
          <div>
            <RichText node={page.fields.fullBio} />
          </div>
        {/if}
      </div>
    </div>
  </div>

  {#if page.fields.trailingBody}
    <PageBody body={page.fields.trailingBody} class="last-page-element" />
  {/if}
</div>
